import React, { useState, useEffect } from 'react'
import Sidebar from '../mini-comp/Sidebar'
import Topbar from '../mini-comp/Topbar'
import axios from 'axios';
import Cookies from 'js-cookie';
import API_BASE_URL from '../../../config/api';
import Swal from 'sweetalert2';
import { RiEyeLine, RiEditLine, RiDeleteBinLine } from 'react-icons/ri';

const Packages = () => {
  const [packages, setPackages] = useState([]);
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    tier: '',
    description: '',
    price: '',
    module_ids: []
  });

  const fetchPackages = () => {
    const token = Cookies.get('token');
    if (!token) {
      console.error('No token found in cookies');
      setLoading(false);
      return;
    }

    axios.get(`${API_BASE_URL}/api/v1/billing/packages/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
      .then(response => {
        console.log('Packages response:', response.data);
        const packagesData = response.data.packages || response.data || [];
        setPackages(Array.isArray(packagesData) ? packagesData : []);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching packages:', error);
        setLoading(false);
      });
  };

  const fetchModules = () => {
    const token = Cookies.get('token');
    if (!token) return;

    axios.get(`${API_BASE_URL}/api/v1/billing/modules/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
      .then(response => {
        const modulesData = response.data.modules || response.data || [];
        setModules(Array.isArray(modulesData) ? modulesData : []);
      })
      .catch(error => console.error('Error fetching modules:', error));
  };

  useEffect(() => {
    fetchPackages();
    fetchModules();
  }, []);

  const handleInputChange = (e) => {
    const { id, name, value } = e.target;
    const fieldName = name || id;
    setFormData(prev => ({
      ...prev,
      [fieldName]: value
    }));
  };

  const handleModuleSelect = (e) => {
    const selectedOptions = Array.from(e.target.selectedOptions, option => parseInt(option.value));
    setFormData(prev => ({
      ...prev,
      module_ids: selectedOptions
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    const token = Cookies.get('token');
    if (!token) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No token found in cookies'
      });
      setSubmitting(false);
      return;
    }

    try {
      // Format data for API
      const submitData = {
        name: formData.name,
        tier: formData.tier,
        description: formData.description,
        price: parseFloat(formData.price),
        module_ids: formData.module_ids
      };

      const response = await axios.post(
        `${API_BASE_URL}/api/v1/billing/packages/`,
        submitData,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );

      console.log('Package created successfully:', response.data);

      // Close modal
      const modal = document.getElementById('addNewPackage');
      if (modal) {
        const bsModal = window.bootstrap?.Modal?.getInstance(modal);
        if (bsModal) {
          bsModal.hide();
        } else {
          modal.classList.remove('show');
          modal.style.display = 'none';
          document.body.classList.remove('modal-open');
          const backdrop = document.querySelector('.modal-backdrop');
          if (backdrop) backdrop.remove();
        }
      }

      // Reset form
      setFormData({
        name: '',
        tier: '',
        description: '',
        price: '',
        module_ids: []
      });

      // Refresh packages list
      fetchPackages();

      setSubmitting(false);
      Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: 'Package created successfully!',
        timer: 2000,
        showConfirmButton: false
      });
    } catch (error) {
      console.error('Error creating package:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Failed to create package. Please try again.'
      });
      setSubmitting(false);
    }
  };

  const handlePackageClick = (pkg) => {
    setSelectedPackage(pkg);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedPackage(null);
  };

  return (
    <div>
      <Topbar />
      <Sidebar />

      <>{ /* app-content-area-start */}
        <div className="app-content-area">
          <div className="app-content-wrap">
            <div className="container-fluid">
              <div className="row fix">
                <div className="col-xxl-12 col-xl-12 col-lg-12">
                  <div className="card mb-4">
                    <div className="card-header justify-between">
                      <h4 className="d-flex-items gap-10">Packages<span className="badge bg-label-primary">{packages.length}</span></h4>
                      <div className="d-flex flex-wrap gap-15">
                        <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#addNewPackage">
                          Add Package
                        </button>
                      </div>
                    </div>
                  </div>
                  {loading ? (
                    <div className="text-center py-5">
                      <span className="text-muted">Loading packages...</span>
                    </div>
                  ) : packages && packages.length > 0 ? (
                    <div className="row">
                      {packages.map((pkg) => (
                        <div key={pkg.id || pkg.package_id} className="col-xxl-3 col-xl-4 col-lg-4 col-md-4 mb-4">
                          <div className="product-card" style={{ cursor: 'pointer' }} onClick={() => handlePackageClick(pkg)}>
                            <div className="product-thumbs">
                              <ul className="product-action-btn">
                                <li>
                                  <a
                                    href="javascript:void(0);"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handlePackageClick(pkg);
                                    }}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    data-bs-title="View Details"
                                  >
                                    <i className="ri-eye-line" />
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href="javascript:void(0);"
                                    onClick={(e) => e.stopPropagation()}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    data-bs-title="Edit Package"
                                  >
                                    <i className="ri-edit-line" />
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div className="product-content">
                              <h5 className="mb-5 underline">
                                <a
                                  href="javascript:void(0);"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handlePackageClick(pkg);
                                  }}
                                >
                                  {pkg.name || pkg.package_name || 'Unnamed Package'}
                                </a>
                              </h5>
                              <p className="mb-2">
                                {pkg.description || pkg.desc || 'No description available'}
                              </p>
                              {pkg.price && (
                                <p className="price">
                                  ${pkg.price}
                                  {pkg.old_price && (
                                    <span className="old-price">${pkg.old_price}</span>
                                  )}
                                </p>
                              )}
                              {pkg.status && (
                                <span className={`badge ${pkg.status === 'active' || pkg.status === 'Active' ? 'bg-label-success' : 'bg-label-danger'}`}>
                                  {pkg.status}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-5">
                      <span className="text-muted">No packages found</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        { /* app-content-area-end */}</>

      {/* Add Package Modal */}
      <div
        className="modal fade"
        id="addNewPackage"
        tabIndex="-1"
        aria-labelledby="addNewPackageLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addNewPackageLabel">Add New Package</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label htmlFor="name" className="form-label">Package Name <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="tier" className="form-label">Tier <span className="text-danger">*</span></label>
                    <select
                      className="form-select"
                      id="tier"
                      name="tier"
                      value={formData.tier}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select Tier</option>
                      <option value="essential">Essential</option>
                      <option value="professional">Professional</option>
                      <option value="enterprise">Enterprise</option>
                    </select>
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="description" className="form-label">Description <span className="text-danger">*</span></label>
                  <textarea
                    className="form-control"
                    id="description"
                    name="description"
                    rows="3"
                    value={formData.description}
                    onChange={handleInputChange}
                    required
                  ></textarea>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label htmlFor="price" className="form-label">Price <span className="text-danger">*</span></label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control"
                      id="price"
                      name="price"
                      value={formData.price}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="module_ids" className="form-label">Select Modules <span className="text-danger">*</span></label>
                    <select
                      className="form-select"
                      id="module_ids"
                      name="module_ids"
                      multiple
                      value={formData.module_ids}
                      onChange={handleModuleSelect}
                      style={{ height: '120px' }}
                      required
                    >
                      {modules.map(module => (
                        <option key={module.id || module.module_id} value={module.id || module.module_id}>
                          {module.name || module.module_name}
                        </option>
                      ))}
                    </select>
                    <div className="form-text">Hold Ctrl (Windows) or Command (Mac) to select multiple modules.</div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="submit" className="btn btn-primary" disabled={submitting}>
                  {submitting ? 'Creating...' : 'Create Package'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Package Details Modal */}
      {showModal && selectedPackage && (
        <div
          className={`modal fade ${showModal ? 'show' : ''}`}
          id="packageDetailsModal"
          tabIndex="-1"
          style={{ display: showModal ? 'block' : 'none', backgroundColor: 'rgba(0,0,0,0.5)' }}
          onClick={handleCloseModal}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {selectedPackage.name || selectedPackage.package_name || 'Package Details'}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseModal}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row mb-4">
                  <div className="col-md-6">
                    <h6 className="text-muted mb-2">Package Name</h6>
                    <p className="mb-3">{selectedPackage.name || selectedPackage.package_name || 'N/A'}</p>
                  </div>
                  <div className="col-md-6">
                    {selectedPackage.description || selectedPackage.desc ? (
                      <div className="mb-4">
                        <h6 className="text-muted mb-2">Description</h6>
                        <p>{selectedPackage.description || selectedPackage.desc}</p>
                      </div>
                    ) : null}
                  </div>
                </div>



                <div className="row mb-4">
                  {selectedPackage.price && (
                    <div className="col-md-6">
                      <h6 className="text-muted mb-2">Price</h6>
                      <p className="mb-3">
                        <span className="price">${selectedPackage.price}</span>
                        {selectedPackage.old_price && (
                          <span className="old-price ms-2">${selectedPackage.old_price}</span>
                        )}
                      </p>
                    </div>
                  )}
                  {selectedPackage.duration && (
                    <div className="col-md-6">
                      <h6 className="text-muted mb-2">Duration</h6>
                      <p className="mb-3">{selectedPackage.duration}</p>
                    </div>
                  )}
                </div>

                {/* Modules List */}
                <div className="mb-4">
                  <h6 className="text-muted mb-3">Included Modules</h6>
                  {selectedPackage.modules && selectedPackage.modules.length > 0 ? (
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Module Name</th>
                            <th>Description</th>

                          </tr>
                        </thead>
                        <tbody>
                          {selectedPackage.modules.map((module, index) => (
                            <tr key={module.id || module.module_id || index}>
                              <td>{module.name || module.module_name || 'N/A'}</td>
                              <td>{module.description || module.desc || 'N/A'}</td>

                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <p className="text-muted">No modules included in this package.</p>
                  )}
                </div>

                {/* Additional Package Details */}
                {(selectedPackage.created_at || selectedPackage.updated_at) && (
                  <div className="row">
                    {selectedPackage.created_at && (
                      <div className="col-md-6">
                        <h6 className="text-muted mb-2">Created At</h6>
                        <p className="mb-3">{new Date(selectedPackage.created_at).toLocaleDateString()}</p>
                      </div>
                    )}
                    {selectedPackage.updated_at && (
                      <div className="col-md-6">
                        <h6 className="text-muted mb-2">Last Updated</h6>
                        <p className="mb-3">{new Date(selectedPackage.updated_at).toLocaleDateString()}</p>
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    // Handle edit action here
                    handleCloseModal();
                  }}
                >
                  Edit Package
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Packages